"use client"
import Image from "next/image";
import logo from "../../../public/loghi/logo.png";
import { Button } from "../ui/button";
import { useRouter } from "next/navigation";

export default function HeroSection() {
	const router = useRouter();

	return (
		<section className="hero relative flex flex-col -mt-24 h-[100vh] pb-[0px] 3xl:pb-[15.5vw] overflow-hidden bg-(--background)">
			<div className="text-left sm:text-center relative z-10 flex flex-col items-start sm:items-center justify-start p-4 pt-8 pb-0 sm:px-4">
				<div className="flex flex-col items-start sm:items-center gap-2">
					<Image
						src={logo}
						alt="Logo Santa Marta"
						width={200}
						height={200}
						className="hidden sm:block shrink-0 mb-2"
					/>
					<div className="flex sm:items-center sm:justify-center gap-3 flex-wrap">
						<h2 className="text-4xl font-extrabold uppercase">
							<span className="text-(--foreground)">Scuola dell'infanzia </span>
							<span className="text-(--card-foreground)">Santa Marta</span>
						</h2>
					</div>
					<p className="max-w-2xl text-(--muted-foreground) text-base md:text-lg">
						"I ragazzi sono talenti preziosi che il Signore mette nelle nostre mani" <br /> Beato Tommaso Reggio
					</p>

					{/* CTA opzionale */}
					<Button
						 onClick={() => router.push("/lascuola")}
						className="cursor-pointer bg-(--btn-bg) text-(--btn-foreground) font-semibold text-base sm:text-lg md:text-xl px-6 py-4 sm:px-8 sm:py-4 shadow-md transition-all duration-300 hover:bg-(--btn-hover) hover:shadow-lg"
					>
						Scopri di più!
					</Button>
				</div>
			</div>

			{/* Banner in basso */}
			<div className="relative h-[360px] md:h-[440px] lg:h-[400px] -mt-20">
				<Image
					src="/herobanner.webp"
					alt="Hero banner"
					fill
					className="object-cover"
					loading="eager"
					priority
				/>
				<div className="pointer-events-none absolute inset-0" />
			</div>
		</section>
	);
}
